"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getFactory = getFactory;
exports.isValidLegendClickHandler = isValidLegendClickHandler;
exports.LegendClickHandlers = void 0;

require("core-js/modules/es6.object.freeze");

var _hideSeriesLegendClickHandlerFactory = _interopRequireDefault(require("./hide-series-legend-click-handler-factory"));

var _legendClickResolver = _interopRequireDefault(require("./legend-click-resolver"));

exports.legendClickResolver = _legendClickResolver.default;

/**
 * Retrieve the factory for a given legend click handler
 * @package
 *
 * @param {LegendClickHandlers} name The name of the desiredd formatter factory
 * @returns {function} Factory which takes chart data and options to return a formatter
 */
function getFactory(name) {
  if (isValidLegendClickHandler(name) && name === LegendClickHandlers.HIDE_SERIES) {
    return _hideSeriesLegendClickHandlerFactory.default;
  }

  throw new Error("Provided name is not a valid legend click handler factory. Provided value ".concat(name));
}
/**
 * Return whether or not a string is a valid TooltipFormatter
 * @param {string} type String to validate
 * @returns {boolean} true if valid, false if invalid
 */


function isValidLegendClickHandler(type) {
  return LegendClickHandlers.hasOwnProperty(type);
}
/**
 * Enum for available legend click handlers
 * @enum {string}
 */


var LegendClickHandlers = {
  HIDE_SERIES: 'HIDE_SERIES'
};
exports.LegendClickHandlers = LegendClickHandlers;
Object.freeze(LegendClickHandlers);